// @flow
import type { FilterParamsType } from '../../../components/types'

type State = {|
  campaignList: Array<Object>,
  collapsedCampaignsIds: Array<number>,
  archivedAudienceIds: Array<number>,
  archivedCampaignIds: Array<number>,
  filterParams: FilterParamsType,
  checkedAudiencesIds: Array<number>,
  isLoading: boolean,
  isPriceBudgetModalOpen: boolean,
  isTableHeadersModalOpen: boolean,
  headers: Array<string>,
  isLoadingEstimates: boolean
|}

type InitialAction = {|
  +type: 'CAMPAIGN_TABLE.INIT',
  +state: State
|}

type PatchAction = {|
  +type: 'CAMPAIGN_TABLE.PATCH',
  +state: $Shape<State>
|}

type Action = InitialAction | PatchAction

export type { State }

const initialFilterParams: FilterParamsType = {
  audienceActivityStatus: '',
  audienceName: '',
  provider: '',
  campaignId: '',
  datepicker: '',
  statisticFilters: []
}

const initialState: State = {
  campaignList: [],
  collapsedCampaignsIds: [],
  archivedAudienceIds: [],
  archivedCampaignIds: [],
  filterParams: initialFilterParams,
  checkedAudiencesIds: [],
  isLoading: false,
  isPriceBudgetModalOpen: false,
  isTableHeadersModalOpen: false,
  headers: [],
  isLoadingEstimates: false
}

export function init(state: State): Action {
  return {
    type: 'CAMPAIGN_TABLE.INIT',
    state
  }
}

export function patch(diff: $Shape<State>): Action {
  return {
    type: 'CAMPAIGN_TABLE.PATCH',
    state: diff
  }
}

function fromInitial(initial: State): State {
  return {
    campaignList: initial.campaignList || [],
    collapsedCampaignsIds: initial.collapsedCampaignsIds || [],
    archivedAudienceIds: initial.archivedAudienceIds || [],
    archivedCampaignIds: initial.archivedCampaignIds || [],
    filterParams: initial.filterParams || initialFilterParams,
    checkedAudiencesIds: initial.checkedAudiencesIds || [],
    isLoading: false,
    isPriceBudgetModalOpen: false,
    isTableHeadersModalOpen: false,
    headers: initial.headers || [],
    isLoadingEstimates: initial.isLoadingEstimates || false
  }
}

export default function reducer(state: State = initialState, action: Action) {
  switch (action.type) {
    case 'CAMPAIGN_TABLE.INIT': {
      return fromInitial(action.state)
    }
    case 'CAMPAIGN_TABLE.PATCH': {
      return { ...state, ...action.state }
    }
    default:
      return state
  }
}
